"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NetworkHealthBufferedDispatcher = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var NetworkHealthBufferedDispatcher = exports.NetworkHealthBufferedDispatcher = /*#__PURE__*/function () {
  function NetworkHealthBufferedDispatcher(dispatch, setAttendeeNetworkHealth) {
    _classCallCheck(this, NetworkHealthBufferedDispatcher);
    _defineProperty(this, "bufferedData", {});
    this.dispatch = dispatch;
    this.setAttendeeNetworkHealth = setAttendeeNetworkHealth;
    this.startDispatchWorker();
  }
  _createClass(NetworkHealthBufferedDispatcher, [{
    key: "updateNetworkHealthData",
    value: function updateNetworkHealthData(attendeeId, uploadBandwidth, downloadBandwidth, audioPacketLoss, audioJitter, audioLatency, audioMOS, videoPacketLoss, videoJitter, videoLatency, videoMOS, videoFrame, networkQuality) {
      if (!this.bufferedData[attendeeId]) {
        this.bufferedData[attendeeId] = {};
      }
      Object.assign(this.bufferedData[attendeeId], {
        uploadBandwidth: uploadBandwidth,
        downloadBandwidth: downloadBandwidth,
        audioPacketLoss: audioPacketLoss,
        audioJitter: audioJitter,
        audioLatency: audioLatency,
        audioMOS: audioMOS,
        videoPacketLoss: videoPacketLoss,
        videoJitter: videoJitter,
        videoLatency: videoLatency,
        videoMOS: videoMOS,
        videoFrame: videoFrame,
        networkQuality: networkQuality
      });
    }
  }, {
    key: "updateReceivedFrameData",
    value: function updateReceivedFrameData(attendeeId, receivedFrame) {
      if (!this.bufferedData.hasOwnProperty(attendeeId)) {
        this.bufferedData[attendeeId] = {};
      }
      this.bufferedData[attendeeId]['receivedFrame'] = receivedFrame;
    }
  }, {
    key: "startDispatchWorker",
    value: function startDispatchWorker() {
      var _this = this;
      setInterval(function () {
        _this.dispatch(_this.setAttendeeNetworkHealth(_this.bufferedData));
        _this.bufferedData = {};
      }, 3000);
    }
  }], [{
    key: "initialize",
    value: function initialize(dispatch, setAttendeeNetworkHealth) {
      if (!NetworkHealthBufferedDispatcher.instance) {
        NetworkHealthBufferedDispatcher.instance = new NetworkHealthBufferedDispatcher(dispatch, setAttendeeNetworkHealth);
      }
    }
  }]);
  return NetworkHealthBufferedDispatcher;
}();
_defineProperty(NetworkHealthBufferedDispatcher, "instance", null);